import React from "react";
var __jsx = React.createElement;
import { twMerge } from "tailwind-merge";
/**
 * Full-height page background behind a result screen: light backdrop, content
 * centered on desktop, top-aligned on mobile.
 */
export function ResultPageContainer(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex min-h-[calc(100vh-64px)] w-full flex-col bg-[#f7f9fc] px-4 py-6 sm:min-h-[70vh] sm:items-center sm:justify-center sm:py-10", className)
  }, children);
}
/**
 * Centered result column for payment success / failure / pending screens:
 * a white card with status icon + title + message + body, and an optional
 * footer block (e.g. contact card) below it.
 */
export function ResultShell(_ref2) {
  var icon = _ref2.icon,
    title = _ref2.title,
    message = _ref2.message,
    children = _ref2.children,
    footer = _ref2.footer,
    className = _ref2.className,
    headerClassName = _ref2.headerClassName;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex w-full max-w-[520px] flex-col gap-4", className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 rounded-2xl border border-solid border-[#e6e9ef] bg-white p-4 sm:p-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col items-center gap-3 text-center", headerClassName)
  }, icon, /*#__PURE__*/React.createElement("h1", {
    className: "text-xl font-bold text-[#00143c] sm:text-2xl"
  }, title), message != null && /*#__PURE__*/React.createElement("p", {
    className: "text-sm text-[#8a94a6]"
  }, message)), children), footer);
}